/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRotate = createReactComponent("rotate", "IconRotate", [
  ["path", { d: "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5", key: "svg-0" }]
]);

export { IconRotate as default };
//# sourceMappingURL=IconRotate.js.map
